(() => {
  const recipeName = (title) => {
    const name = title
      .replace(/\b(?:pack de |pack |capsules? |dosettes? |compatibles? |nespresso®? |senseo®? |aluminium |boîte de |boite de )/giu, ' ')
      .replace(/\b(?:\d+\s*[x×]\s*\d+|[x×]\s*\d+|\d+\s*(?:capsules?|dosettes?))\b/giu, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^[\s–—-]+|[\s–—-]+$/g, '');
    const numberedRecipe = name.match(/(?:l['’]|le |la |les )?(?:espresso équilibré|espresso intense|décaféiné|équilibré|ristretto|espresso|classique|lungo|corsé|doux)\s*N[°º]\s*\d+/iu);
    return numberedRecipe?.[0] || name || title;
  };

  const initialise = (section) => {
    const source = section.querySelector('[data-legal-review-source]');
    const target = section.querySelector('[data-legal-review-cards]');
    const next = section.querySelector('[data-legal-review-next]');
    if (!source || !target) return;

    let rendering = false;
    const pageSize = () => window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
    let currentIndex = 0;
    const showPage = () => {
      const cards = [...target.children];
      const count = pageSize();
      if (currentIndex >= cards.length) currentIndex = 0;
      cards.forEach((card, index) => {
        card.hidden = index < currentIndex || index >= currentIndex + count;
      });
      if (next) next.hidden = cards.length <= count;
    };
    next?.addEventListener('click', () => {
      currentIndex = (currentIndex + pageSize()) % target.children.length;
      showPage();
    });
    window.addEventListener('resize', showPage);
    const render = async () => {
      if (rendering || !target.hidden) return;
      const seen = new Set();
      const reviews = [...source.querySelectorAll('.jdgm-carousel-item')].filter((item) => {
        const id = item.dataset.reviewId;
        if (id && seen.has(id)) return false;
        if (id) seen.add(id);
        const score = Number(item.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label')?.match(/[1-5]/)?.[0]);
        return item.querySelector('a.jdgm-carousel-item__product[href*="/products/"]')
          && item.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim()
          && score >= 4;
      }).slice(0, 20);
      if (!reviews.length) return;
      rendering = true;

      const cards = await Promise.all(reviews.map(async (review) => {
        const productLink = review.querySelector('a.jdgm-carousel-item__product[href*="/products/"]');
        const productUrl = new URL(productLink.getAttribute('href'), location.origin);
        if (productUrl.origin !== location.origin) return null;
        const productPath = productUrl.pathname.match(/^(.*\/products\/[^/]+)\/?$/)?.[1];
        if (!productPath) return null;

        const existingImage = review.querySelector('.jdgm-carousel-item__product-image');
        let imageUrl = existingImage?.dataset.src || existingImage?.getAttribute('src');
        let productName = review.querySelector('.jdgm-carousel-item__product-title')?.textContent.trim();
        if (!imageUrl || !productName) {
          try {
            const response = await fetch(`${productPath}.js`);
            if (!response.ok) return null;
            const product = await response.json();
            imageUrl ||= product.featured_image;
            productName ||= product.title;
          } catch {
            return null;
          }
        }
        if (!imageUrl || !productName) return null;

        const card = document.createElement('article');
        card.className = 'legal-home-products__review-card';
        const link = document.createElement('a');
        link.className = 'legal-home-products__review-product';
        link.href = `${productPath}#judgeme_product_reviews`;
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = productName;
        image.loading = 'lazy';
        const name = document.createElement('span');
        name.textContent = recipeName(productName);
        link.append(image, name);

        const rating = document.createElement('p');
        rating.className = 'legal-home-products__review-rating';
        const score = Number(review.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label')?.match(/[1-5]/)?.[0]) || 0;
        rating.textContent = score ? '★'.repeat(score) + '☆'.repeat(5 - score) : '';
        if (score) rating.setAttribute('aria-label', `${score} étoiles sur 5`);

        const quote = document.createElement('blockquote');
        quote.textContent = review.querySelector('.jdgm-carousel-item__review-body').textContent.trim();
        const byline = document.createElement('footer');
        byline.textContent = review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || 'Client Legal';
        card.append(link, rating, quote, byline);
        return card;
      }));

      const usable = cards.filter(Boolean);
      if (usable.length) {
        target.replaceChildren(...usable);
        target.hidden = false;
        showPage();
        source.classList.add('legal-home-products__review-source--hidden');
      }
      rendering = false;
    };

    render();
    const observer = new MutationObserver(() => {
      if (!target.hidden) {
        observer.disconnect();
        return;
      }
      render();
    });
    observer.observe(source, { childList: true, subtree: true });
  };

  document.querySelectorAll('.legal-home-reviews-proof').forEach(initialise);
})();
